<template>
  <div class="pt20">
    <div class="back" @click="back(false)">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="" />
      <span>{{ $t('admin.content.news.add.back') }}</span>
    </div>
    <h4>
      {{
        id
          ? `${$t('admin.content.news.add.edit')}${columnTitle}`
          : `${$t('admin.content.news.add.create')}${columnTitle}`
      }}
    </h4>
    <a-form :form="form" layout="vertical">
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.news.add.title.label')" :colon="false">
          <a-input
            allowClear
            :placeholder="$t('admin.content.news.add.title.placeholder')"
            v-decorator="[
              'title',
              { rules: [{ required: true, message: $t('admin.content.news.add.title.required') }] }
            ]"
          ></a-input>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.news.add.content.label')" :colon="false">
          <div
            v-decorator="[
              'content',
              { rules: [{ required: true, message: $t('admin.content.news.add.content.required') }] }
            ]"
          >
            <Editor v-model="contentValue" @uploadImg="uploadImg" @changeText="changeText"></Editor>
          </div>
        </a-form-item>
      </div>
      <div class="list">
        <a-form-item class="full" :label="$t('admin.content.news.add.document.label')" :colon="false">
          <Upload
            @uploadData="uploadData"
            coverType="word"
            :fileUrl="form.getFieldValue('documentUrl')"
            :accept="['doc', 'docx', 'pdf']"
            :desc="[$t('admin.content.news.add.document.supportTypes')]"
            v-decorator="['documentUrl']"
          ></Upload>
        </a-form-item>
        <a-form-item class="full" :label="$t('admin.content.news.add.status.label')" :colon="false">
          <a-select
            allowClear
            v-decorator="[
              'status',
              { rules: [{ required: true, message: $t('admin.content.news.add.status.required') }] }
            ]"
            :placeholder="$t('admin.content.news.add.status.placeholder')"
          >
            <a-select-option v-for="item in stateList" :key="item.id" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item class="full recommend" :label="$t('admin.content.news.add.recommend.label')" :colon="false">
          <div v-decorator="['recommend']"></div>
          <div style="display: flex; align-items: center; ">
            <a-radio-group class="radioGroup" v-model="recommend" @change="changeRecommend">
              <a-radio :value="false">{{ $t('admin.content.news.add.recommend.no') }}</a-radio>
              <a-radio :value="true">{{ $t('admin.content.news.add.recommend.yes') }}</a-radio>
            </a-radio-group>
            <a-select
              :placeholder="$t('admin.content.news.add.recommend.placeholder')"
              v-if="recommend"
              v-model="recommendLevelSelect"
            >
              <a-select-option v-for="item in recommendLevel" :key="item.id" :value="item.id">
                {{ $t(`admin.content.news.add.recommend.levels.${item.id}`) }}
              </a-select-option>
            </a-select>
          </div>
        </a-form-item>
      </div>
      <div class="submit-button">
        <a-button type="primary" @click="handleSubmit">{{ $t('admin.content.news.add.submit') }}</a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import Editor from '@/components/Editor/tinymce.vue'
import Upload from '@/components/upload/index.vue'

import { newsSave, newsDetail } from '@/api/admin'
export default {
  components: {
    Editor,
    Upload
  },
  data() {
    return {
      id: undefined,
      contentValue: '',
      stateList: [
        {
          id: 1,
          name: this.$t('admin.content.news.add.status.options.open')
        },
        {
          id: 2,
          name: this.$t('admin.content.news.add.status.options.close')
        }
      ],
      recommend: false,
      recommendLevelSelect: 0,
      cover: '',
      recommendLevel: [
        {
          id: 1,
          name: '一级'
        },
        {
          id: 2,
          name: '二级'
        },
        {
          id: 3,
          name: '三级'
        },
        {
          id: 4,
          name: '四级'
        },
        {
          id: 5,
          name: '五级'
        },
        {
          id: 6,
          name: '六级'
        },
        {
          id: 7,
          name: '七级'
        },
        {
          id: 8,
          name: '八级'
        },
        {
          id: 9,
          name: '九级'
        },
        {
          id: 10,
          name: '十级'
        }
      ],
      form: this.$form.createForm(this),
      columnTitle: this.$route.query.columnTitle
    }
  },
  watch: {
    contentValue: {
      handler(val) {
        this.form.setFieldsValue({
          content: val
        })
      }
    }
  },
  methods: {
    back() {
      this.$router.back()
    },
    changeRecommend(e) {
      this.recommendLevelSelect = this.recommend ? 1 : 0
    },
    uploadImg(url) {
      // if (this.cover) return
      this.cover = url
    },
    uploadData(data) {
      this.form.setFieldsValue({
        documentUrl: data[0].url
      })
      this.documentName = data[0].name
    },
    changeText(val) {
      this.contentTextValue = val
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.form.setFieldsValue({
        recommend: this.recommend ? this.recommendLevelSelect : 0
      })
      this.form.validateFields((err, values) => {
        if (!err) {
          const iframe = document.querySelector('iframe')
          const iframeDocument = iframe.contentDocument || iframe.contentWindow.document
          const firstImg = iframeDocument.querySelector('img')
          const data = Object.assign(values, {
            id: this.id,
            columnId: this.columnId,
            rawContent: this.contentTextValue,
            cover: firstImg ? firstImg.src : '',
            documentName: this.documentName
          })
          newsSave(data).then(res => {
            if (res.code == 200) {
              const tip = this.id
                ? this.$t('admin.content.news.add.success.edit')
                : this.$t('admin.content.news.add.success.create')
              this.$message.success(tip)
              this.$router.back()
            }
          })
        }
      })
    },
    async getNewsDetail() {
      const res = await newsDetail({ id: this.id })
      if (res.code == 200) {
        this.form.setFieldsValue({
          documentUrl: res.data.documentUrl,
          title: res.data.title,
          status: res.data.status
        })
        this.contentValue = res.data.content
        this.contentTextValue = res.data.rawContent
        this.cover = res.data.cover
        this.documentName = res.data.documentName
        this.recommendLevelSelect = res.data.recommend
        this.recommend = res.data.recommend > 0
      }
    }
  },
  mounted() {
    this.id = this.$route.query.id || undefined
    this.columnId = this.$route.query.columnId || undefined
    if (this.id) {
      this.getNewsDetail()
    }
  }
}
</script>

<style lang="less" scoped>
h4 {
  font-size: 16px;
  font-weight: 800;
  color: #000000;
  line-height: 22px;
  border-bottom: 1px solid #ededed;
  margin-bottom: 20px;
  padding-bottom: 12px;
}
.admin {
  width: 100%;
  cursor: pointer;
  text-align: right;
  margin-bottom: 21px;
  .user-logo {
    width: 26px;
    height: 26px;
    border-radius: 100%;
    margin-right: 12px;
  }
  .down {
    width: 10px;
    margin-left: 5px;
  }
}
/deep/.ant-input-suffix {
  right: 12px;
  img {
    width: 23px;
    cursor: pointer;
  }
}
.back {
  width: 80px;
  height: 34px;
  display: flex;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  border-radius: 25px;
  margin-bottom: 26px;
  align-items: center;
  justify-content: center;
  border: 1px solid #d6d6d6;
  img {
    height: 10px;
    margin-right: 9px;
  }
}
/deep/.ant-form {
  .title {
    display: flex;
    font-size: 14px;
    font-weight: 600;
    color: #627587;
    line-height: 20px;
    position: relative;
    padding: 12px 17px;
    margin-bottom: 30px;
    align-items: center;
    border-bottom: 1px solid #ededed;
    &::before {
      left: 0;
      content: '';
      width: 4px;
      height: 12px;
      border-radius: 2px;
      position: absolute;
      background: #6b738c;
    }
  }
  .list {
    padding-right: 0px;
    .ant-form-item-label {
      label {
        color: #000000;
      }
    }
    .ant-form-item {
      width: 100%;
      padding-left: 6px;
      &:first-child {
        padding-left: 0;
      }
    }
    .ant-input-affix-wrapper .ant-input-suffix {
      position: absolute;
      img {
        width: 23px;
        height: 23px;
      }
    }
    .ant-calendar-picker div {
      position: relative;
      .ant-calendar-picker-input {
        width: 228px;
        height: 35px;
        margin-right: 0;
        color: #000000;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d8dce0;
      }
    }
    .ant-input,
    .ant-select {
      border-radius: 4px;
      color: #000000;
    }
    .full .ant-input,
    .full .ant-select {
      width: 100%;
      height: 35px;
      color: #000000;
      margin-right: 0;
      border-radius: 4px;
    }
    .recommend {
      // display: flex;
      .ant-radio-group {
        display: flex;
        align-items: center;
        .ant-radio-wrapper {
          margin-bottom: 0px;
          margin-right: 20px;
          .ant-radio {
            color: #000000;
          }
        }
      }
      .ant-select {
        width: 107px;
        margin-left: 0px;
        border-radius: 4px;
        color: #000000;
        height: 35px;
      }
    }
    .ant-input-wrapper.ant-input-group {
      .ant-input {
        border-right: 0;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
      .ant-input-group-addon {
        background: #fff;
        font-size: 14px;
        font-weight: 400;
        color: #5e7a92;
        line-height: 20px;
        border-top-right-radius: 20px;
        border-bottom-right-radius: 20px;
      }
    }
  }
  .submit-button {
    width: 100%;
    // padding-left: 500px;
    text-align: center;
  }
}
</style>
